import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { applicationHistory } from '../../common/application-history';

import {
    clearSelectedDiscItems,
    disableDiscItemSelectionMode,
    enableDiscItemSelectionMode,
    deleteSelectedDiscItems} from '../../disc/actions/disc-actions';
import ConfirmationDialog from "../../common/components/confirmation-dialog";

class DiscItemSelectModeHeader extends PureComponent {
    constructor(props) {
        super(props);
        this.cancelSelection = this.cancelSelection.bind(this)
        this.deleteSelectedDiscItems = this.deleteSelectedDiscItems.bind(this)
        this.state = {
            isDeleteConfirmationDialogOpen: false
        }
    }
    cancelSelection() {
        this.props.clearSelectedDiscItems();
        this.props.disableDiscItemSelectionMode();
        applicationHistory.goBack();
    }
    deleteSelectedDiscItems(){
        this.props.deleteSelectedDiscItems(this.props.disc)
        this.setState({isDeleteConfirmationDialogOpen:false})
        this.props.disableDiscItemSelectionMode();
        applicationHistory.goBack();
    }
    render() {
        const { disableAlbumItemSelectionMode, clearSelectedAlbumItems, enableAlbumItemSelectionMode, album } = this.props;

        return (
            <header className="select-mode header-flex-container">
                <div className="header-flex-left">
                    <div className="header-item header-item-left" onClick={this.cancelSelection}>
                        <div className="header-icon cancel" />
                        <span className="cancel-text">Cancel</span>
                    </div>

                </div>
                {this.props.isSomeSelected &&
                <div className="header-flex-right">
                    <div className="header-item header-item-right" onClick={()=>this.setState({isDeleteConfirmationDialogOpen:true})}>
                        <div className="header-icon delete-white" />
                        <div className="header-label">Delete</div>
                    </div>
                </div>
                }
                {this.state.isDeleteConfirmationDialogOpen &&
                <ConfirmationDialog title={"Delete"} message={"Are you sure you want to remove these items from this disc?"} isOpen={this.state.isDeleteConfirmationDialogOpen} onYesAction={this.deleteSelectedDiscItems} onNoAction={()=>this.setState({isDeleteConfirmationDialogOpen:false})}/>
                }

            </header>
        );
    }
}

DiscItemSelectModeHeader.propTypes = {
    enableDiscItemSelectionMode: PropTypes.func,
    disableDiscItemSelectionMode: PropTypes.func,
    clearSelectedDiscItems: PropTypes.func,
    disc: PropTypes.object,
};

const mapStateToProps = state => {
    return {
        disc: state.disc.selectedDiscDetail,
        isSomeSelected: state.disc.selectedDiscDetail != null && state.disc.selectedDiscDetail.chapters.filter(chap=> chap.selected === true).length > 0
    };
};

const mapDispatchToProps = dispatch => {
    return {
        clearSelectedDiscItems: () => dispatch(clearSelectedDiscItems()),
        disableDiscItemSelectionMode: () => dispatch(disableDiscItemSelectionMode()),
        enableDiscItemSelectionMode: () => dispatch(enableDiscItemSelectionMode()),
        deleteSelectedDiscItems: (selectedDiscDetail) => dispatch(deleteSelectedDiscItems(dispatch,selectedDiscDetail))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscItemSelectModeHeader);



// WEBPACK FOOTER //
// ./src/header/components/disc-item-select-mode-header.jsx